import { Form } from 'antd';

import { SCard } from 'app/components/StaycationUI';
import { FormLineLayout } from 'app/components/commons/Form/FormLineLayout/FormLineLayout';
import { DatePicker, TimePicker } from 'app/components/fields/dayjsPickers';

import './LimitedEdition.scss';

type Props = {
  disabled: boolean;
  timezone?: string;
};

export const LimitedEdition = ({ disabled, timezone }: Props) => {
  const form = Form.useFormInstance();
  const launchDate = Form.useWatch('launchDate', form);

  return (
    <SCard title="Limited edition" className="pack-form limited-edition-card">
      <FormLineLayout label="Launch Date" isOptional labelOnTop>
        <div className="limited-edition-field-wrapper">
          <Form.Item name="launchDate">
            <DatePicker
              format="DD-MM-YYYY"
              placeholder="Select date"
              disabled={disabled}
            />
          </Form.Item>
          <div className="helper-text">
            When you set a launch date, package will be visible in prelaunch
            state until then. Sales will start after chosen date and time.
          </div>
        </div>
      </FormLineLayout>
      <FormLineLayout label="Launch Time" isOptional labelOnTop>
        <div className="limited-edition-field-wrapper">
          <Form.Item name="launchTime">
            <TimePicker
              format="HH:mm"
              placeholder="Select time"
              disabled={disabled || !launchDate}
            />
          </Form.Item>
        </div>
      </FormLineLayout>
    </SCard>
  );
};
